import { render, staticRenderFns } from "./participate-button.vue?vue&type=template&id=fc56ceba&scoped=true&"
import script from "./participate-button.vue?vue&type=script&lang=js&"
export * from "./participate-button.vue?vue&type=script&lang=js&"
import style0 from "./participate-button.vue?vue&type=style&index=0&id=fc56ceba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc56ceba",
  null
  
)

/* custom blocks */
import block0 from "./locale.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fquake%2Fworkspace%2Fauction%2Ftokyo-auction-frontend%2Fsrc%2Fcomponents%2Fauction%2Fparticipate-button.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports